import { render, staticRenderFns } from "./iconShop.vue?vue&type=template&id=70a71ed6&scoped=true"
import script from "./iconShop.vue?vue&type=script&lang=js"
export * from "./iconShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a71ed6",
  null
  
)

export default component.exports